export const getManualRedemptionPolicy = (settings) => {
  const manualRedemption = settings?.voucher?.manualRedemption ?? {};
  const requiresCustomerPhone = manualRedemption.requireCustomerPhone ?? false;

  return {
    shouldShowPhoneNumber:
      (settings?.dompet?.redemption?.isRequiredPhone ?? false) ||
      requiresCustomerPhone,
    requiresCustomerPhone,
    shouldCheckCustomerLimit:
      manualRedemption.checkCustomerLimit ?? false,
  };
};

export const getBookVoucherCount = (skus) =>
  (skus ?? []).reduce((total, { quantity = 0 }) => total + quantity, 0);
